import { Box, useTheme } from "@mui/material";
import React from "react";
import { LoadingSlides } from "./Common";

const PageLoader = ({ height = "100vh" }) => {
  const theme = useTheme();
  const brandColor = theme.custom.brandColor;
  return (
    <Box height={height} width={"100%"} className="flex-xy-center">
      <LoadingSlides bgColor={brandColor} />
    </Box>
  );
};

export default PageLoader;
